module.exports = __webpack_public_path__ + "static/process1-18d1d671e86b733d5f59517845b28fa7.png";